import { ControlTypeEnum, IAction } from "../abstraction/index";
import { ControlBaseModel } from "./ControlBaseModel";
import { ActionPosition } from "./index";

// Bouton Action
export class ActionModel extends ControlBaseModel {
	public constructor() {
		super();

		this.Position = ActionPosition.DockedBottomLeft;
	}

	public static create(src: IAction): ActionModel {
		let item: ActionModel = new ActionModel();

		item.Id = src.Id;
		item.Key = src.Code;

		item.Action = src.Action;
		item.ControlType = src.Type;

		item.Text = src.Text;
		item.WebService = src.WebService;
		item.Target = src.Target;
		item.Context = src.Context;

		item.Visible = src.Visible;
		item.Disable = src.Disable;
		//item.URL = src.URL;
		item.YesNo = "";

		
		return item;
	}

	public adapt(): IAction {
		return {
			Action: this.Action,
			Code: this.Key,
			Context: this.Context,
			Id: this.Id,
			Target: this.Target,
			Text: this.Text,
			Type: this.ControlType,
			WebService: this.WebService,
			Visible: this.Visible,
			Disable: this.Disable,
			//URL: this.URL,
		}
	}

	Key: string;
	Id: number;
	ControlType: ControlTypeEnum;

	Text: string;

	Icon: string;
	WebService: string;
	Target: number;
	Context: string;
	Action: number;
	Popup: string;		// IO_BPOPUP

	Color: string;
	Class: string;				// Classe l'int�gralit� du control 
	InlineStyle: string;		// Style inline portant sur l'int�gralit� du controle
	InnerCSS: string;			// Classe appliqu� uniquement sur la zone TEXTE enfant (span=)
	//InputInlineStyle: string;
	Visible: boolean = true;
	Disable: boolean;
	YesNo: string;
	URL: string;
	clic: string;
	bsSize: string;
	SkipValidation: boolean;

	RowVisiblityCond: string;	// Condition de visibilit� du bouton dans un tableau
	VisibilityCond: string;		// Condition de visibilit� du bouton 
	
	Position: ActionPosition;

}



